import axios from 'axios';
import React, { useContext, useState } from 'react'
import { useParams } from 'react-router-dom';
import { BaseUrlContext } from '../Context/BaseUrl';
import { useEffect } from 'react';

import Swal from 'sweetalert2';
export default function RegistraionForm() {
    let { course_id, course_name } = useParams();
    const { baseUrl, imgUrl } = useContext(BaseUrlContext);

    let [mobile, setMobile] = useState();
    let [firstName, setFirstName] = useState();
    let [secondName, setSecondName] = useState();
    let [email, setEmail] = useState();
    let [lastName, setLastName] = useState();
    let [selectedCourse, setSelectedCourse] = useState();
    let [payment, setPayment] = useState('');
    let [selectedSession, setSelectedSession] = useState(0);
    let [onlinePayment, setOnlinePayment] = useState(0);
    let [responseData, setResponseData] = useState({});
    const handleCheckboxChange = (e) => {
        const value = e.target.checked ? 1 : 0;
        setOnlinePayment(value);
    };
    async function registartionForCourses(e) {
        e.preventDefault();

        const bodyFormData = new FormData();
        bodyFormData.append('mobile', mobile);
        bodyFormData.append('email', email);
        bodyFormData.append('first_name', firstName);
        bodyFormData.append('second_name', secondName);
        bodyFormData.append('last_name', lastName);
        bodyFormData.append('course_id', course_id);
        bodyFormData.append('selected_session', selectedSession);
        bodyFormData.append('online_payment', onlinePayment);

        await axios.post(`${baseUrl}/payment`, bodyFormData)
            .then(response => {
                // Handle the response
                if (response.data.Ecode === 200) {
                    console.log(response.data.Edata);
                    setPayment(response.data.EHtml);
                    setResponseData(response.data.Edata)
                    // const scriptElement = document.createElement('script');
                    // scriptElement.innerHTML = response.data.EHtml;
                    const script = document.createElement('script');
                    script.innerText = response.data.EHtml;
                    document.body.appendChild(script);
                    // const paymentDiv = document.getElementById('payment');
                    // paymentDiv.innerHTML = response.data.EHtml;


                    // window.Checkout.showLightbox(); // Modify this according to the script's requirements
                    // document.getElementById('payment').innerHTML = response.data.EHtml;
                } else {
                    setPayment(response.data.Emsg)
                }

            })
            .catch(error => {

                // Handle any errors
                console.error(error);

            });

    }

    // let BASEURL = 'https://my-health.sghcairo.net/patient_portal_testing';

    async function handleSubmit(data) {
        // e.preventDefault();
        // const bodyFormData = new FormData();
        // bodyFormData.append('mobile', responseData.request.mobile);
        // bodyFormData.append('full_name', responseData.trainee_name);
        // bodyFormData.append('amount', responseData.amount);
        // bodyFormData.append('course_id', responseData.course_id);
        try {
            const response = await axios.post(baseUrl + '/payment/state', {
                phone: responseData.request.mobile,
                full_name: responseData.trainee_name,
                course_id: responseData.course_id,
                email: responseData.request.email,
                amount: responseData.amount,
                data: data, // Assuming 'data' is already defined in your component
            });

            const msg = JSON.stringify(response.data.result);
            console.log('reaponse' + response.data);

            // if (data !== 0) {
            if (msg === 'SUCCESS') {

                console.log('reeeeeeesss' + data);
                Swal.fire({
                    position: 'top-end',
                    icon: 'success',
                    title: 'Thanks Mr. ' + responseData.trainee_name,
                    text: 'An email has been sent to your provided email address for confirmation.',
                    showConfirmButton: false,
                    timer: 9500
                });
            } else {
                Swal.fire({
                    icon: 'error',
                    title: msg.msg,
                    showConfirmButton: true
                });
            }
            // }
        } catch (error) {
            Swal.fire({
                icon: 'error',
                title: 'Request failed: ' + error.message,
                showConfirmButton: true
            });
        }
    }

    window.handleSubmit = handleSubmit;
    // window.errorCallback = function (error) {
    //     console.log(JSON.stringify(error));
    // };

    // window.cancelCallback = function () {
    //     console.log('Payment cancelled');
    //     handleSubmit(0);
    // };

    // window.completeCallback = function (data) {
    //     console.log(data);
    //     handleSubmit(data);
    // };


    // GET ALL COURSES
    let [courses, setCourses] = useState([]);
    async function getAllCourses() {

        await axios.post(`${baseUrl}/get_courses`)
            .then(response => {
                // Handle the response
                if (response.data.Ecode === 200) {
                    console.log(response.data.Edata);
                    setCourses(response.data.Edata);
                }

            })
            .catch(error => {

                // Handle any errors
                console.error(error);
            });

    }
    useEffect(() => {
        getAllCourses();
    }, [])

    return <>
        <div id="wrapper" class="clearfix">

            {/* <!-- Start main-content --> */}
            <div class="main-content-area">
                {/* <!-- Section: home --> */}
                <section id="home" class="divider parallax layer-overlay overlay-dark-9" data-tm-bg-img="images/bg/bg4.jpg" style={{ backgroundImage: `url('/images/bg/bg4.jpg')` }}>
                    <div class="display-table">
                        <div class="display-table-cell">
                            <div class="container pt-100 pb-100">
                                <div class="row">
                                    <div class="col-md-6 offset-md-3">
                                        {/* <div class="text-center mb-60"><a href="#" class=""><img alt="images" src="images/logo-wide-white.png" /></a></div> */}
                                        <div class="bg-white-fc border-1px p-25">
                                            <h4 class="text-theme-colored1 text-uppercase m-0">Register Now</h4>
                                            <div class="line-bottom mb-30"></div>
                                            {/* <p>Lorem ipsum dolor sit amet, consectetur elit.</p> */}
                                            <form class="mt-30" method="post" onSubmit={registartionForCourses}>
                                                <div class="row">

                                                    <div class="col-sm-12">
                                                        <div class="mb-3 mb-10">
                                                            <input name="first name" class="form-control required" type="text" placeholder="Enter First Name" aria-required="true" value={firstName} onChange={(e) => setFirstName(e.target.value)} />
                                                        </div>
                                                    </div>
                                                    <div class="col-sm-12">
                                                        <div class="mb-3 mb-10">
                                                            <input name="form_phone" class="form-control required" type="text" placeholder="Enter Second Name" aria-required="true" value={secondName} onChange={(e) => setSecondName(e.target.value)} />
                                                        </div>
                                                    </div>
                                                    <div class="col-sm-12">
                                                        <div class="mb-3 mb-10">
                                                            <input name="form_appontment_date" class="form-control required date-picker" type="text" placeholder="Enter Last Name" aria-required="true" value={lastName} onChange={(e) => setLastName(e.target.value)} />
                                                        </div>
                                                    </div>
                                                    <div class="col-sm-12">
                                                        <div class="mb-3 mb-10">
                                                            <div class="input-group mb-3">
                                                                <span class="input-group-text" id="basic-addon1"><i className="flaticon-contact-043-email-1 font-icon sm-display-block"></i></span>

                                                                <input name="form_appontment_date" class="form-control required" type="email" placeholder="Enter Email" aria-required="true" value={email} onChange={(e) => setEmail(e.target.value)} />
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="col-sm-12">
                                                        <div class="mb-3 mb-10">
                                                            <div class="input-group mb-3">
                                                                <span class="input-group-text" id="basic-addon1"><i className="flaticon-contact-042-phone-1 font-icon"></i></span>

                                                                <input name="form_name" class="form-control" type="number" placeholder="Enter Mobile" aria-required="true" aria-label="Username" aria-describedby="basic-addon1" value={mobile} onChange={(e) => setMobile(e.target.value)} />
                                                            </div>
                                                        </div>
                                                    </div>
                                                    {/* <div class="col-sm-12">
                                                        <div class="mb-3 mb-10">
                                                            <select class="form-select" value={selectedCourse} onChange={(e) => setSelectedCourse(e.target.value)} aria-label="Default select example">
                                                                <option selected value={course_id} >{course_name}</option>
                                                                {courses.map((course, index) => <>
                                                                    <option key={index} value={course.id}>{course.name}</option>

                                                                </>)}
                                                            </select>
                                                        </div>
                                                    </div> */}
                                                    <div class="col-sm-12">
                                                        <div class="mb-3 mb-10">
                                                            <div class="form-check">
                                                                <input class="form-check-input" type="checkbox" checked={onlinePayment === 1}
                                                                    onChange={handleCheckboxChange} id="flexCheckDefault" />
                                                                <label class="form-check-label" for="flexCheckDefault">
                                                                    If you want to pay online you can select on online payment checkbox
                                                                </label>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div class="mb-3 tm-sc-button mb-0 mt-20">
                                                    <input name="form_botcheck" class="form-control" type="hidden" value="" />
                                                    <button type="submit" class="btn btn-theme-colored1 btn-sm" data-loading-text="Please wait..."> Submit </button>
                                                </div>
                                            </form>

                                        </div>
                                    </div>







                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </div>
            {/* <!-- end main-content --> */}



        </div>
        {/* <div id="payment" dangerouslySetInnerHTML={{ __html: payment }}>

        </div> */}
    </>
}
